import React from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { WELCOME_PATH } from 'shared/constants/route';
import { getPathWithoutLang } from 'shared/lib/converter';

type SignupBenefitLineProps = {
  className?: string;
};

/** 가입 혜택(쿠폰·가이드) 안내 — 웰컴 랜딩에서 가입한 경우에만 혜택을 주므로 그때만 노출 */
const SignupBenefitLine = ({ className = '' }: SignupBenefitLineProps) => {
  const { t } = useTranslation('auth');
  const location = useLocation();

  if (getPathWithoutLang(location.pathname) !== WELCOME_PATH) return null;

  return <p className={`text-center text-c2 font-semibold text-primary ${className}`}>🎁 {t('signup.benefit')}</p>;
};

export default SignupBenefitLine;
